<template>
  <div class="mainUser">
    <menberMenu :tit-names="titNames" :tit-urls="titUrls"></menberMenu>
    <div class="mainBox ">
      <div class="listContent">
        <div class="content">
          <div class="contentText clear" style="padding:20px">
            <ul class="l">
              <li class="succed-title">
                <i class="fa fa-finish  marR5"></i>
                <span class="title">Place an order successfully</span>
              </li>
              <li style="margin:15px 0">
                <label><span class="colGray9">Order No.：</span>
                  <a class="colBlue" @click="clkWayBtn">
                    <b>{{WaybillNO}}</b>
                  </a>
                </label>
                <label style="color:#ddd;margin:0 20px">|</label>
                <label><span class="colGray9">Estimated total cost：</span><b class="colRed">US ${{Number(ordCost).toFixed(2)}}</b></label>
              </li>
              <li>
                <div  class="colRed">
                  <p v-show="ordCost > BillConvertAmount"><i class="fa fa-tips marR5" style="margin-top:-3px;"></i><span>The order will not be processed until the payment is completed. Please pay according to the estimated cost!</span></p>
                 <p v-show="ordCost <= BillConvertAmount"><i class="fa fa-tips marR5" style="margin-top:-3px;"></i><span>The order will not be processed until the payment is completed</span></p>
                </div>
              </li>
            </ul>
            <ul class="r">
              <li>
                <a class="s-blueBtn" @click="clkMake">Recharge</a>
              </li>
              <li class="marTop10">
                <a class="s-blueBtn" @click="clkWayBtn">Details</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="listContent">
        <div class="checkTitle borTLRad borTRRad"><h2>In order not to affect the normal delivery of your goods, you need to complete the following matters:</h2></div>
        <div class="content">
          <div class="contentText" style="padding:20px">
            <table border="0" cellspacing="0" cellpadding="0" width="100%" class="TableCss dataInput">
              <tr>
                <td align="left" class="veTop" width="4%;"><span class="radNum">1</span></td>
                <td>
                  <h3>Print label</h3>
                  <p class="colGray9" style="line-height:20px;">In order to ensure the accurate warehousing of your goods without delay, please inform your supplier to print the address label on the side of each package. If the label is not printed, the warehouse will have the right to reject the goods.</p>
                </td>
              </tr>
              <tr>
                <td align="left" class="veTop"><span class="radNum">2</span></td>
                <td>
                  <h3>Label the quantity of the shipment</h3>
                  <p class="colGray9" style="line-height:20px;">
                    Please inform your supplier that the quantity of the goods should be clearly written on the conspicuous position of the outer box of the goods and the self-delivered express waybill, such as one order of one unit, <span class="colRed">one order of three units</span>, etc., so that the warehouse tally personnel can tally the goods, avoid confusion and cause unnecessary losses.
                  </p>
                </td>
              </tr>
               <tr>
                <td></td>
                <td>
                  <b>Please inform your supplier to prepare the goods as described above.</b><a class="lineBlueBtn marL30" @click="clkNotiBtn">Notify my supplier</a>
                </td>
              </tr>
            
            </table>
          </div>
        </div>
      </div>
    
    </div>
        <!--遮罩层-->
    <div class="frameBg" v-show="showModal"></div>
    <div class="frameInput2" v-show="supplierBox">
        <div class="frameHead indexHead clear">
          <p class="l">Notify my supplier</p><p @click="getClose" class="r" style="font-size:26px;">×</p>
        </div>
        <div class="content" style="padding:0 25px;">
            <table border="0" cellspacing="0" cellpadding="0" class="TableCss marTop30" >
              <tr>
                <td colspan="2" align="left">
                  <b>Order No.：{{WaybillNO}}</b>
                  <p class="colGray">Order labels and stocking precautions will be notified to your supplier via email.</p>
                </td>
              </tr>
               <tr>
                <td width="13%" align="right" class="veTop"><h3>Emali：</h3></td>
                <td>
                  <input type="text" class="inputLine" style="width:90%;" v-model="emaliInput" @blur="blurInput" />
                  <p class="colRed" v-show="showEmaliMsg">Please enter a valid email address</p>  
                </td>
              </tr>           
            </table>     
        </div>
         <div class="framePwBtn">
            <a style="margin-left:31%;font-size:13px;" class="sureLineA l" @click="getClose">Cancel</a>
            <a class="sureA l marL10" style="font-size:13px;" @click="clkSendBtn">Send notification</a>
          </div>  
      </div>

  </div>
</template>
<script type="text/ecmascript-6">
import Vue from "vue";
import { post, fetch, Del, put } from "../../../ask/axios";
import menberMenu from '../../../components/userCenter/public/menberPageMenu.vue'
    export default {
        components:{menberMenu},
        data (){
            return {
              api: {
              url: "",
              param: "",
              data: "",
              response: {},
              message: ""
            },

            titNames: "Express shipment,Booked",
            titUrls: "/exp/expList,",

            //弹框
            showModal:false,
            supplierBox:false,
            emaliInput:'', //邮箱Input

            WaybillNO:'',//订单号
            ordCost:null,//预估费用

            shipperEmali:'', //发送给供应商邮箱
            showEmaliMsg:false, //提示不能为空

            BillConvertAmount:null,//账户余额
            }
        },
        created(){
           this.costApi();
          this.WaybillNO=this.$route.query.ord
          this.ordCost=this.$route.query.ordCost
        },
        methods:{
          //点击立即充值
          clkMake(){
             window.location.href='/payment/myPayment?ordCost='+ Number(this.ordCost).toFixed(2)
          },
          //美元账户余额查询
          costApi(){
           let that = this;
           this.api.param={
            QueryType:1
           }
          this.api.url=this.$api02+"/api/EbayCustomer/MyBill/GetCusAmount";
          post(this.api.url,this.api.param).then(function (res) {
            if(res.Results){
              that.BillConvertAmount=res.Results.BillConvertAmount  
            }
          })
          },
          //点击订单号跳转到我的订单详情页面
          clkWayBtn(){
           window.location.href='/exp/expDetails?ord='+this.WaybillNO+'&news=0'
          },

          //关闭弹框
          getClose(){
            this.showModal=false
            this.supplierBox=false
            this.showEmaliMsg=false
          },
          //点击notify按钮
          clkNotiBtn(){
            this.showModal=true
            this.supplierBox=true
            this.emaliInput=this.$route.query.shipperEmali
          },
          //验证邮箱是否为空 和邮箱格式验证
          blurInput(){
            let validEm= /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!validEm.test(this.emaliInput)){
              this.showEmaliMsg=true
            }else{
              this.showEmaliMsg=false
            }
          },
          //点击发送按钮
          clkSendBtn(){
            if(!this.emaliInput){
               this.showEmaliMsg=true
               return false
            }else{
              this.showEmaliMsg=false
             this.sendEmaliApi();
            }
          },
          //发送邮箱给供应商接口
          sendEmaliApi(){
           let that = this;
           this.api.param={
            WaybillNO:this.WaybillNO,
           }
           //邮箱 this.emaliInput
           let em=that.emaliInput.split(',')
          this.api.param.Emails=em

          this.api.url=this.$api02+"/api/EbayCustomer/SupplierInfo/NewAccountInfoSendEmail";
          post(this.api.url,this.api.param).then(function (res) {
            if(res.ErrorCode=='C0001'){
                that.$confirm("You have successfully notified your supplier!", "", {
                  customClass: "custom-message-box", //自定义添加Class
                  confirmButtonText: "Confirm",
                  cancelButtonText: "Cancel",
                  cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
                  closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
                  showCancelButton: false, //去掉取消按钮
                  showClose: false, //去掉右上角的取消（X）
                  // type: 'warning',
                  center: true
                }).then(() => {
                  that.showModal=false
                  that.supplierBox=false
                }).catch(() => {
                   that.showModal=false
                   that.supplierBox=false
                });
                return false;         
            }else if(res.IsOK==false || res.ErrorCode=='C0002'){
               that.$confirm("failed", "", {
                  customClass: "custom-message-box", //自定义添加Class
                  confirmButtonText: "Confirm",
                  cancelButtonText: "Cancel",
                  cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
                  closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
                  showCancelButton: false, //去掉取消按钮
                  showClose: false, //去掉右上角的取消（X）
                  // type: 'warning',
                  center: true
                }).then(() => {
                  that.showModal=false
                  that.supplierBox=false
                }).catch(() => {
                  that.showModal=false
                  that.supplierBox=false
                });
            }
          })
          },

        }
    }
</script>

 <style>
  /*局部修改elementUI样式*/
  /*!*取消按钮*!*/
  /*.el-message-box__wrapper .btn-custom-cancel {float:right;margin:0 120px 0 0 !important;;}*/
  /*!*确定或者删除按钮*!*/
  /*.el-message-box__wrapper .el-message-box__btns button:nth-child(2){margin:0 0 0 120px !important;}*/
  @import "../../../assets/css/tipsMessage.css";
</style>
<style scoped>
  @import "../../../assets/css/userCenterCss.css";
  @import "../../../assets/css/frame.css";
  .radNum{background:#f2f2f2;border-radius:30px;padding:5px 10px;color:#999;}
  .succed-title .title{color: #000 ; font-size: 16px;font-weight: bold;vertical-align: top;line-height: 28px;}
  .succed-title i{ color: #1aad19; font-size: 26px;}
  .s-blueBtn{border: 1px solid #004FB1;  border-radius: 30px;  background: #004FB1;  color: #fff !important;  width: 98px;  height: 28px; display: block; text-align: center; line-height: 28px;}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/exp/expSucceed.vue